/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-08-28 10:57:18
 * @LastEditors: huangfuchunmei
 * @message: 使用指南-下载文档
 */
import React from "react";
import { docList } from '@/common/const'
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia"

interface IProps {
  ctry: string;
  words: Record<string, string>;
}
const icon_file = require('../../../assets/icon_file.svg')
const icon_download = require('../../../assets/icon_download.svg')
const DownloadFile = (props:IProps) => {
  const {ctry, words} = props

  return (
    <section className={styles['section']}>
      <h2 className={styles['section-title']}>
        {words?.support_usage_guide_doc_title}
        {/* Document guidance */}
      </h2>
      <div className={styles['file-list']}>
        {docList.map(item => (
          <div className={styles['file-itme']} key={item.id}>
            <p className={styles['file-title']}>
              <LazyMedia type="image" src={icon_file} alt="" />
              <span>{item.title}</span>
            </p>
            <a
              className={styles['download-file']}
              target="_blank"
              download={item.title}
              href={item.url}>
              <LazyMedia type="image" src={icon_download} alt="" />
              <span>{item.size}</span>
            </a>
          </div>
        ))}
        
      </div>
    </section>
  )
}
export default DownloadFile